<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";
  import Accordion from "../molecules/Accordion/Accordion.svelte";
  import CheckboxGroup from "../molecules/FormFields/CheckboxGroup.svelte";
  import Radio from "../molecules/FormFields/Radio.svelte";

  /** @typedef {import("svelte").ComponentProps<Radio | CheckboxGroup>} FormItemProps */

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  export let componentName = undefined;

  let component = componentName === "checkbox" ? CheckboxGroup : Radio;

  /** @typedef {Object} FiltersListType
   * @property {string} headline - Radio or Checkbox header label
   * @property {FormItemProps} bodyProps - Radio or Checkbox body component
   * @property {boolean} active - accordion active state
   */
  /** @type {FiltersListType[]} */
  export let filters;

  /** The class to be applied to the each accordion item
   *  @type {string}
   * */
  export let itemContainerClass = "";

  /** The class to be applied to the body of the slot item
   *  @type {string}
   * */
  export let itemBodySlotClass = "";

  $: items = filters.map((item) => {
    return {
      ...item,
      body: component,
      bodyProps: item.bodyProps
    };
  });

  const dispatch = createEventDispatcher();
</script>

<Accordion
  {id}
  {items}
  {itemContainerClass}
  {itemBodySlotClass}
  on:checkBoxSelectionGroup={(e) => {
    dispatch("checkBoxSelectionGroup", {
      value: e.detail.value,
      name: e.detail.name,
      checkbox: e.detail.checkbox
    });
  }}
/>
